import React from 'react';
import '../styles/Pagination.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    // 페이지 번호 배열 생성 (최대 5개)
    const getPageNumbers = () => {
        const pageNumbers = [];
        let startPage = Math.max(0, currentPage - 2);
        let endPage = Math.min(totalPages - 1, currentPage + 2);
        
        // 표시할 페이지 수가 5개 미만인 경우 조정
        if (endPage - startPage < 4) {
            if (startPage === 0) {
                endPage = Math.min(4, totalPages - 1);
            } else if (endPage === totalPages - 1) {
                startPage = Math.max(0, totalPages - 5);
            }
        }
        
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        
        return pageNumbers;
    };
    
    return (
        <div className="pagination">
            {/* 처음 페이지로 이동 */}
            <button 
                className="pagination-button"
                onClick={() => onPageChange(0)}
                disabled={currentPage === 0}
            >
                &laquo;
            </button>
            
            {/* 이전 페이지로 이동 */}
            <button 
                className="pagination-button"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 0}
            >
                &lt;
            </button>
            
            {/* 페이지 번호 */}
            {getPageNumbers().map(number => (
                <button
                    key={number}
                    className={`pagination-button ${currentPage === number ? 'active' : ''}`}
                    onClick={() => onPageChange(number)}
                >
                    {number + 1}
                </button>
            ))}
            
            {/* 다음 페이지로 이동 */}
            <button 
                className="pagination-button"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages - 1}
            >
                &gt;
            </button>
            
            {/* 마지막 페이지로 이동 */}
            <button 
                className="pagination-button"
                onClick={() => onPageChange(totalPages - 1)}
                disabled={currentPage === totalPages - 1}
            >
                &raquo;
            </button>
        </div>
    );
};

export default Pagination;
